var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSatelliteSolid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15001_96064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.28142 0.218359C6.98767 -0.0753906 6.51267 -0.0753906 6.22205 0.218359L3.22205 3.21836C2.9283 3.51211 2.9283 3.98711 3.22205 4.27773L6.0158 7.07149L5.53142 7.55586C4.75955 7.19961 3.9033 6.99961 3.00017 6.99961C2.00955 6.99961 1.0783 7.24024 0.256423 7.66211C-0.0248269 7.80899 -0.0654519 8.18398 0.159548 8.40586L3.52205 11.7715L3.00955 12.284C2.9283 12.2621 2.8408 12.2496 2.75017 12.2496C2.19705 12.2496 1.75017 12.6965 1.75017 13.2496C1.75017 13.8027 2.19705 14.2496 2.75017 14.2496C3.3033 14.2496 3.75017 13.8027 3.75017 13.2496C3.75017 13.159 3.73767 13.0746 3.7158 12.9902L4.2283 12.4777L7.5908 15.8402C7.8158 16.0652 8.1908 16.0246 8.33455 15.7434C8.75955 14.9215 9.00017 13.9902 9.00017 12.9996C9.00017 12.0965 8.80017 11.2402 8.44392 10.4715L8.9283 9.98711L11.7189 12.7809C12.0127 13.0746 12.4877 13.0746 12.7783 12.7809L15.7783 9.78086C16.072 9.48711 16.072 9.01211 15.7783 8.72149L12.9845 5.92773L14.7033 4.20898C15.0939 3.81836 15.0939 3.18398 14.7033 2.79336L13.2033 1.29336C12.8127 0.902735 12.1783 0.902735 11.7877 1.29336L10.0689 3.01211L7.28142 0.218359ZM12.2502 11.1871L9.98767 8.92461L11.9283 6.98399L14.1908 9.24961L12.2502 11.1902V11.1871ZM7.07205 6.01211L4.80955 3.74961L6.75017 1.80898L9.01267 4.07149L7.07205 6.01211Z",
    fill: "#303030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15001_96064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatelliteSolid1);
export default __webpack_public_path__ + "static/media/satellite-solid-1.dd446c606b9175102ef1e81905309cb3.svg";
export { ForwardRef as ReactComponent };